module.exports = __webpack_public_path__ + "img/77_1.eba7e37b.jpg";